import { AddOutline24Icon } from "@vygruppen/spor-icon-react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DropsButton } from "shared/components/Spor";

type ButtonProps = {
  onClick: () => void;
};

export const AddRuleButton: FC<ButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <DropsButton
      variant="tertiary"
      leftIcon={<AddOutline24Icon />}
      size="sm"
      maxWidth="max-content"
      onClick={onClick}
    >
      {t("Legg til regel")}
    </DropsButton>
  );
};
